import { useMemo } from 'react';
import { Link as RouterLink } from 'react-router-dom';

// material-ui
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// assets
import MailOutlined from '@ant-design/icons/MailOutlined';
import TeamOutlined from '@ant-design/icons/TeamOutlined';
import { useAuth } from 'contexts/AuthContext';

import avatar1 from 'assets/images/users/avatar-1.png';

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

export default function ProfileTab() {
  const { user, workspace } = useAuth();
  const workspaceBadges = useMemo(
    () =>
      [workspace?.role, workspace?.name]
        .filter(Boolean)
        .map((item) => String(item)),
    [workspace?.name, workspace?.role]
  );

  return (
    <Stack spacing={2.25} sx={{ p: 2.5 }}>
      <Stack spacing={1.5}>
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Avatar alt="Liance user" src={avatar1} sx={{ width: 48, height: 48 }} />
          <Box>
            <Typography variant="subtitle1">{user?.name || 'Workspace user'}</Typography>
            <Typography variant="body2" color="text.secondary">
              {workspace?.role || 'Workspace member'}
            </Typography>
          </Box>
        </Stack>

        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
          <Chip icon={<MailOutlined />} label={user?.email || 'No email'} size="small" variant="outlined" />
          <Chip icon={<TeamOutlined />} label={workspace?.name || 'Liance'} size="small" variant="outlined" />
        </Stack>
      </Stack>

      <Divider />

      <Box>
        <Typography variant="subtitle2" sx={{ mb: 1.25 }}>
          Workspace access
        </Typography>
        <Stack
          spacing={1}
          sx={{
            p: 1.5,
            borderRadius: 3,
            border: '1px solid',
            borderColor: 'secondary.200',
            backgroundColor: 'grey.0'
          }}
        >
          <Typography variant="body2">
            Your role determines whether you can invite teammates, connect systems, or simply observe the workspace in read-only mode.
          </Typography>
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            {workspaceBadges.map((item) => (
              <Chip key={item} label={item} size="small" variant="outlined" />
            ))}
          </Stack>
          <Typography variant="caption" color="text.secondary">
            Invite delivery is still manual for now. Create the invite in Team, then copy the accept link and share it directly.
          </Typography>
        </Stack>
      </Box>

      <Stack direction="row" spacing={1.25}>
        <Button fullWidth component={RouterLink} to="/profile" variant="contained" size="small">
          Edit profile
        </Button>
        <Button fullWidth component={RouterLink} to="/team" variant="outlined" size="small" color="secondary">
          Manage team
        </Button>
      </Stack>
    </Stack>
  );
}
